<section class="max-w-7xl mx-auto px-4 py-16">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
    <div class="space-y-6">
      <h1 class="text-4xl lg:text-5xl font-semibold text-[#0D3543] leading-tight">
        {{ 'about.heroTitle' | translate }}
      </h1>
      <p class="text-white-darkest text-lg font-normal leading-relaxed max-w-xl">
        {{ 'about.heroDescription' | translate }}
      </p>
    </div>

    <div class="flex justify-center lg:justify-end">
      <div class="relative w-full max-w-md">
        <img
          src="assets/images/Image1.png"
          alt="Trendy Fashion"
          class="rounded-lg shadow-sm w-full object-cover aspect-[4/5]"
        />
      </div>
    </div>
  </div>
</section>

<!-- 2  -->
<section
  class="max-w-7xl mx-auto px-4 bg-gradient-to-b from-[#FAFAFA] to-[#FFFFFF] border-b border-[#E5E5E5]"
>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
    <div class="order-2 lg:order-1">
      <img
        src="assets/images/Image2.png"
        alt="Shop Smart"
        class="shadow-sm w-full object-cover aspect-[4/5] lg:aspect-square"
      />
    </div>

    <div class="order-1 lg:order-2 space-y-6 lg:pl-10">
      <h2 class="text-4xl font-semibold text-[#0D3543] leading-tight">
        {{ 'about.section2Title' | translate }}
      </h2>
      <p class="text-white-darkest leading-relaxed text-base font-normal">
        {{ 'about.section2Description' | translate }}
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
        <div class="flex items-center gap-4">
          <div
            class="w-12 h-12 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2187AB]"
          >
            <sham-i-delivery-truck-1 class="*:size-6" />
          </div>
          <div>
            <h4 class="font-medium text-gray text-base">
              {{ 'about.freeShipping' | translate }}
            </h4>
            <p class="text-[11px] text-gray-400">
              {{ 'about.freeShippingDesc' | translate }}
            </p>
          </div>
        </div>

        <div class="flex items-center gap-4">
          <div
            class="w-12 h-12 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2596BE]"
          >
            <sham-i-delivery-truck-1 class="*:size-6" />
          </div>
          <div>
            <h4 class="font-medium text-gray text-base">
              {{ 'about.cashOnDelivery' | translate }}
            </h4>
            <p class="text-xs font-normal text-gray-400">
              {{ 'about.cashOnDeliveryDesc' | translate }}
            </p>
          </div>
        </div>

        <div class="flex items-center gap-4">
          <div
            class="w-12 h-12 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2187AB]"
          >
            <sham-i-delivery-truck-1 class="*:size-6" />
          </div>
          <div>
            <h4 class="font-medium text-gray text-base">
              {{ 'about.customerSupport' | translate }}
            </h4>
            <p class="text-xs font-normal text-gray-400">
              {{ 'about.customerSupportDesc' | translate }}
            </p>
          </div>
        </div>

        <div class="flex items-center gap-4">
          <div
            class="w-12 h-12 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2187AB]"
          >
            <sham-i-delivery-truck-1 class="*:size-6" />
          </div>
          <div>
            <h4 class="font-medium text-gray text-base">
              {{ 'about.easyReturns' | translate }}
            </h4>
            <p class="text-xs font-normal text-gray-400">
              {{ 'about.easyReturnsDesc' | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- 3 -->
<section class="max-w-7xl mx-auto px-4 py-16 lg:py-20">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
    <div class="space-y-6 lg:pr-10">
      <h2 class="text-4xl font-semibold text-[#0D3543] leading-tight">
        {{ 'about.section3Title' | translate }}
      </h2>
      <p class="text-white-darkest text-base font-normal leading-relaxed">
        {{ 'about.section3Description' | translate }}
      </p>

      <ul class="space-y-3">
        <li class="flex items-center gap-3 text-sm text-gray-600">
          <span
            class="w-5 h-5 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2187AB]"
          >
            <sham-i-checkmark class="*:size-4"
          /></span>
          {{ 'about.feature1' | translate }}
        </li>
        <li class="flex items-center gap-3 text-sm font-normal text-gray-600">
          <span
            class="w-5 h-5 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2187AB]"
          >
            <sham-i-checkmark class="*:size-4"
          /></span>
          {{ 'about.feature2' | translate }}
        </li>
        <li class="flex items-center gap-3 text-sm text-gray-600">
          <span
            class="w-5 h-5 shrink-0 bg-[#EDF2EE] rounded-full flex items-center justify-center text-[#2187AB]"
          >
            <sham-i-checkmark class="*:size-4"
          /></span>
          {{ 'about.feature3' | translate }}
        </li>
      </ul>

      <button
        (click)="goHome()"
        class="bg-[#2596BE] hover:bg-[#2589aa] text-[#FFFFFF] text-base font-normal px-10 py-3 rounded-lg mt-4"
      >
        {{ 'about.shopNow' | translate }}
      </button>
    </div>

    <div class="flex justify-center lg:justify-end">
      <img
        src="assets/images/Image3.png"
        alt="Shopping Experience"
        class="shadow-sm w-full object-cover aspect-[4/5] lg:aspect-square"
      />
    </div>
  </div>
</section>

<!-- 4 -->
<section class="bg-[#FFFFFF]">
  <div class="max-w-7xl mx-auto px-4 text-center">
    <h2 class="text-4xl lg:text-5xl leading-tight font-semibold text-[#0D3543] mb-5">
      {{ 'about.whyChooseUs' | translate }}
    </h2>

    <p
      class="max-w-2xl mx-auto font-normal text-white-darkest text-base leading-7 mb-20"
    >
      {{ 'about.whyChooseUsDescription' | translate }}
    </p>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-14 items-stretch">
      <!-- 1 -->
      <article
        class="px-12 py-16 pb-28 rounded-lg flex flex-col items-center text-center transition-all duration-300 hover:bg-[#FFFFFF] hover:shadow-[0px_20px_60px_rgba(0,0,0,0.07)]"
      >
        <div
          class="w-18 h-18 rounded-lg border border-[#2596BE] bg-[#2596BE]/10 flex items-center justify-center text-[#2C9BC2] mb-8"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 40 41"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.7083 0C18.6798 0 17.842 0.442507 17.0794 1.03876C16.3644 1.59563 15.576 2.40185 14.6539 3.34497L14.5897 3.41061C13.6455 4.37624 12.8223 4.75497 11.5537 4.75497C11.3942 4.75497 11.1943 4.74934 10.967 4.74371C10.3858 4.72684 9.63416 4.70436 8.97599 4.76248C8.01349 4.84873 6.81082 5.11689 5.89782 6.05814C4.99215 6.99376 4.73553 8.21813 4.65486 9.19501C4.59986 9.86251 4.6218 10.6256 4.6383 11.2162C4.6438 11.4487 4.64931 11.6531 4.64931 11.8163C4.64931 13.1138 4.27899 13.9556 3.33482 14.9213L3.27064 14.9869C2.34847 15.93 1.56017 16.7363 1.01567 17.4675C0.432674 18.2475 0 19.1044 0 20.1562C0 21.2081 0.432674 22.065 1.01567 22.845C1.56017 23.5762 2.34847 24.3825 3.27064 25.3256L3.33482 25.3912C3.94716 26.0175 4.23504 26.4225 4.39821 26.805C4.55771 27.1781 4.64931 27.6506 4.64931 28.4962C4.64931 28.6594 4.6438 28.8638 4.6383 29.0963C4.6218 29.6907 4.59982 30.4594 4.65665 31.1325C4.74098 32.1169 5.00318 33.3469 5.92351 34.2806C6.83834 35.2069 8.03551 35.4693 8.99067 35.5518C9.64334 35.6081 10.3895 35.5857 10.967 35.5688C11.1943 35.5632 11.3942 35.5575 11.5537 35.5575C12.3622 35.5575 12.8168 35.64 13.1743 35.7919C13.5318 35.9419 13.915 36.2119 14.4907 36.8006C14.6135 36.9263 14.7767 37.1044 14.9637 37.3107C15.3854 37.7719 15.9335 38.3719 16.445 38.8313C17.2224 39.525 18.337 40.3125 19.7083 40.3125C21.0797 40.3125 22.1943 39.525 22.9716 38.8313C23.4831 38.3719 24.0313 37.7719 24.453 37.3107C24.64 37.1044 24.8032 36.9263 24.926 36.8006C25.5017 36.2119 25.8849 35.9419 26.2424 35.7919C26.5999 35.64 27.0545 35.5575 27.863 35.5575C28.0225 35.5575 28.2224 35.5632 28.4497 35.5688C29.0272 35.5857 29.7733 35.6081 30.426 35.5518C31.3812 35.4693 32.5783 35.2069 33.4932 34.2806C34.4135 33.3469 34.6757 32.1169 34.76 31.1325C34.8169 30.4594 34.7949 29.6907 34.7784 29.0963C34.7729 28.8638 34.7674 28.6575 34.7674 28.4962C34.7674 27.6506 34.859 27.1781 35.0185 26.805C35.1816 26.4225 35.4695 26.0175 36.0818 25.3912L36.146 25.3256C37.0682 24.3825 37.8565 23.5762 38.401 22.845C38.984 22.065 39.4167 21.2081 39.4167 20.1562C39.4167 19.1044 38.984 18.2475 38.401 17.4675C37.8565 16.7363 37.0682 15.93 36.146 14.9869L36.0818 14.9213C35.4695 14.295 35.1816 13.89 35.0185 13.5075C34.859 13.1344 34.7674 12.6619 34.7674 11.8163C34.7674 11.6531 34.7729 11.4488 34.7784 11.2181C34.7949 10.6219 34.8169 9.85312 34.76 9.17999C34.6757 8.19562 34.4135 6.96561 33.4932 6.03186C32.5783 5.10561 31.3812 4.84315 30.426 4.76065C29.7733 4.7044 29.0272 4.72684 28.4497 4.74371C28.2224 4.74934 28.0207 4.75497 27.863 4.75497C26.5925 4.75497 25.7712 4.37624 24.827 3.41061L24.7628 3.34497C23.8406 2.40185 23.0523 1.59563 22.3373 1.03876C21.5746 0.442507 20.7368 0 19.7083 0ZM26.0554 17.1319C26.9537 16.6538 27.302 15.5212 26.8345 14.6025C26.367 13.6837 25.2596 13.3275 24.3613 13.8056C21.7433 15.2006 19.6075 17.8706 18.1958 19.9743C17.798 20.5687 17.446 21.1369 17.1417 21.6507C16.9345 21.4707 16.7328 21.3094 16.5495 21.1687C16.1535 20.8631 15.7996 20.625 15.5393 20.4581L15.0865 20.1844H15.0828C14.1937 19.6894 13.0808 20.025 12.5968 20.9363C12.1147 21.8457 12.4447 22.9838 13.3338 23.4788C13.5978 23.6494 14.168 24.0244 14.344 24.1631C14.9545 24.6338 15.5778 25.2262 15.9555 25.8412C16.3111 26.4187 16.9455 26.7544 17.6128 26.7169C18.2783 26.6775 18.8723 26.2706 19.162 25.6556C19.2555 25.4625 19.4939 24.9844 19.6955 24.6206C20.053 23.9625 20.5737 23.0625 21.2208 22.095C22.5592 20.1 24.2734 18.0806 26.0554 17.1319Z"
              fill="#2596BE"
            />
          </svg>
        </div>

        <h3 class="text-2xl font-normal text-[#1E7898] mb-4">
          {{ 'about.qualityTitle' | translate }}
        </h3>

        <p class="text-white-darkest text-base font-normal leading-relaxed">
          {{ 'about.qualityDescription' | translate }}
        </p>
      </article>

      <!--  2 -->

      <article
        class="px-12 py-16 pb-28 rounded-lg flex flex-col items-center text-center transition-all duration-300 hover:bg-[#FFFFFF] hover:shadow-[0px_20px_60px_rgba(0,0,0,0.07)]"
      >
        <div
          class="w-18 h-18 rounded-lg bg-[#2C9BC2] flex items-center justify-center text-[#FFFFFF] mb-8"
        >
          <sham-i-delivery-truck-1 class="*:size-7" />
        </div>

        <h3 class="text-2xl font-normal text-[#1E7898] mb-4">
          {{ 'about.deliveryTitle' | translate }}
        </h3>

        <p class="text-white-darkest text-base font-normal leading-relaxed">
          {{ 'about.deliveryDescription' | translate }}
        </p>
      </article>

      <!--  3 -->
      <article
        class="px-12 py-16 pb-28 rounded-lg flex flex-col items-center text-center transition-all duration-300 hover:bg-[#FFFFFF] hover:shadow-[0px_20px_60px_rgba(0,0,0,0.07)]"
      >
        <div
          class="w-18 h-18 rounded-xl border border-[#43A5C7] bg-[#EAF6FA] flex items-center justify-center text-[#2C9BC2] mb-8"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 41 35"
            fill="none"
          >
            <path
              d="M38.2803 19.8145C39.2563 19.4765 40.328 19.9755 40.6738 20.9297C41.0195 21.8841 40.5083 22.9325 39.5322 23.2705C38.5317 23.617 37.3758 24.3631 36.1514 25.4131C34.9463 26.4464 33.7736 27.6874 32.7354 28.9043C31.7008 30.1169 30.8218 31.2789 30.2012 32.1387C29.8916 32.5675 29.6483 32.919 29.4834 33.1611L29.2393 33.5254C28.8769 34.0828 28.2352 34.4068 27.5605 34.373C26.8858 34.3393 26.2818 33.9531 25.9795 33.3623C25.1533 31.7466 24.4117 31.103 24.0381 30.8594C23.88 30.7563 23.7729 30.7152 23.7305 30.7012C22.7775 30.6146 22.0315 29.8303 22.0313 28.876C22.0313 27.8635 22.8707 27.042 23.9063 27.042C24.0607 27.0435 24.4441 27.0713 24.7432 27.1699C25.1329 27.2788 25.6037 27.4732 26.1182 27.8086C26.6324 28.1438 27.1715 28.6072 27.7129 29.2412C28.3038 28.4515 29.0328 27.521 29.8564 26.5557C30.9688 25.2518 32.2781 23.8573 33.6787 22.6563C35.0599 21.4719 36.6338 20.3846 38.2803 19.8145ZM23.0576 4.76837e-07C26.5056 -1.64135e-05 29.2138 -0.000407473 31.3486 0.235352C33.5276 0.476019 35.2949 0.978196 36.7637 2.11231C37.2033 2.45175 37.6108 2.827 37.9814 3.2334C39.2305 4.60324 39.789 6.26377 40.0547 8.30078C40.3128 10.2797 40.3125 12.7846 40.3125 15.9453V16.1387C40.3125 16.408 40.3129 16.5432 40.2861 16.625C40.2172 16.8353 40.0979 16.9418 39.8779 16.9922C39.7923 17.0117 39.6215 16.9984 39.2803 16.9717C38.643 16.9217 37.9844 16.9995 37.3428 17.2217C35.2124 17.9595 33.3252 19.3025 31.8262 20.5879C30.2789 21.9146 28.8663 23.4239 27.6982 24.793C27.5961 24.9126 27.5451 24.9728 27.4961 25.0098C27.3518 25.1184 27.1986 25.15 27.0215 25.1084C26.9613 25.0942 26.881 25.0567 26.7217 24.9805C26.3237 24.7902 25.9383 24.6463 25.5732 24.541C24.8954 24.3301 24.2146 24.2947 23.9355 24.292H23.9082C21.3194 24.292 19.2207 26.3437 19.2207 28.875C19.2207 29.1931 19.2534 29.504 19.3164 29.8037C19.5792 31.0536 19.7108 31.6784 19.542 31.8809C19.3731 32.0832 18.8755 32.083 17.8809 32.083H17.2549C13.8069 32.083 11.0987 32.0834 8.96387 31.8477C6.78483 31.607 5.01765 31.1049 3.54883 29.9707C3.10917 29.6312 2.70169 29.2561 2.33106 28.8496C1.08198 27.4797 0.523494 25.8193 0.257813 23.7822C-0.000261331 21.8034 -2.50455e-05 19.2991 5.96046e-07 16.1387V15.9453C-2.50474e-05 12.7846 -0.000280874 10.2797 0.257813 8.30078C0.523506 6.26377 1.08203 4.60324 2.33106 3.2334C2.70165 2.827 3.10924 2.45175 3.54883 2.11231C5.01762 0.978196 6.78491 0.476019 8.96387 0.235352C11.0987 -0.000407766 13.8069 -1.64135e-05 17.2549 4.76837e-07H23.0576ZM20.1563 10.083C16.7908 10.083 14.0625 12.7513 14.0625 16.042C14.0627 19.3325 16.7909 22 20.1563 22C23.5216 22 26.2498 19.3325 26.25 16.042C26.25 12.7513 23.5217 10.083 20.1563 10.083ZM7.95996 14.208C6.92924 14.2082 6.09375 15.0296 6.09375 16.042C6.09393 17.0542 6.92935 17.8748 7.95996 17.875H7.97754C9.00815 17.8748 9.84357 17.0542 9.84375 16.042C9.84375 15.0296 9.00826 14.2082 7.97754 14.208H7.95996Z"
              fill="#2596BE"
            />
          </svg>
        </div>

        <h3 class="text-2xl font-normal text-[#1E7898] mb-4">
          {{ 'about.paymentTitle' | translate }}
        </h3>

        <p class="text-white-darkest text-base font-normal leading-relaxed">
          {{ 'about.paymentDescription' | translate }}
        </p>
      </article>
    </div>
  </div>
</section>
